<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-card-title>
            <div class="text-h2">
              Условия правила: {{ rule ? rule.name : "" }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="conditions"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения. Выберите правило в таблице 'Правила программы' "
            >
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                >
                  <v-card>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col
                            :md="conditionItems.widthCol"
                            cols="12"
                            sm="12"
                          >
                            <v-select
                              v-model="Condition.parameter"
                              :items="conditionParameterList"
                              label="Параметр"
                              @change="onGetParameter"
                            />
                          </v-col>
                          <v-col
                            v-if="conditionItems.control === conditionControlEnum.textField || conditionItems.control === conditionControlEnum.list || conditionItems.control === conditionControlEnum.textDateField"
                            cols="12"
                            md="4"
                            sm="12"
                          >
                            <v-select
                              v-model="Condition.comparisonOp"
                              :items="conditionItems.conditionComparisonOpList"
                              label="Операция сравнения"
                            />
                          </v-col>
                          <v-col
                            v-if="conditionItems.control === conditionControlEnum.textField"
                            cols="12"
                            md="4"
                            sm="12"
                          >
                            <v-text-field
                              v-model="Condition.value"
                              label="Значение"
                              placeholder="Значение параметра"
                            >
                              <template
                                v-if="conditionItems.postButtonShow"
                                v-slot:append-outer
                              >
                                <v-menu
                                  offset-y
                                  style="top: -12px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="onOpenDialog"
                                    >
                                      mdi-account-search-outline
                                    </v-icon>
                                  </template>
                                </v-menu>
                                <item-list
                                  :item-list="nomenclatureList"
                                  :headers="nomenclatureHeaders"
                                  :dialog-visible="dialogVisible"
                                  :multiple="true"
                                  :selected-item="selectedItems"
                                  item-key="id"
                                  @close="onCloseDialogNomenclature"
                                  @getItem="onGetNomenclatureCode"
                                />
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col
                            v-if="conditionItems.control === conditionControlEnum.textDateField"
                            cols="12"
                            md="4"
                            sm="12"
                          >
                            <text-date-field
                              v-model="Condition.value"
                              label="Значение"
                              :hint="hintDateField"
                              @change="onDateChange"
                            />
                          </v-col>

                          <v-col
                            v-if="conditionItems.control === conditionControlEnum.checkBox"
                            cols="2"
                            md="1"
                            sm="2"
                            class="col-check-box"
                          >
                            <input
                              v-model="Condition.value[0]"
                              class="check-box"
                              type="checkbox"
                              false-value="0"
                              true-value="1"
                            >
                          </v-col>
                          <v-col
                            v-if="conditionItems.control === conditionControlEnum.checkBox"
                            cols="10"
                            md="4"
                            sm="10"
                            class="col-check-box"
                          >
                            <span>Значение параметра</span>
                          </v-col>
                          <v-col
                            v-if="conditionItems.control === conditionControlEnum.list"
                            cols="12"
                            md="4"
                            sm="12"
                          >
                            <v-select
                              v-model="Condition.value[0]"
                              label="Значение"
                              :items="itemList"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue"
                        text
                        @click="conditionId > 0 ? onSave() : onCreate()"
                      >
                        {{
                          conditionId > 0 ? "Сохранить" : "Создать"
                        }}
                      </v-btn>
                      <v-btn
                        color="blue"
                        text
                        @click="onCloseDialog"
                      >
                        Отмена
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.actions="{ item }">
                <task-menu
                  @delete="deleteCondition(item)"
                  @edit="editCondition(item)"
                />
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row dense>
              <v-col
                cols="12"
                class="d-flex justify-center flex-wrap"
              >
                <v-tooltip
                  v-if="isRuleObject"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      color="primary"
                      v-bind="attrs"
                      @click="createCondition"
                      v-on="on"
                    >
                      <v-icon
                        large
                        class="ml-3"
                      >
                        mdi-plus-circle-outline
                      </v-icon>
                      <span class="md-1 mx-3">Добавить условие</span>
                    </v-btn>
                  </template>
                  <span>Создать новое условие</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="explainCondition.length > 0">
      <v-col>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header />
            <v-expansion-panel-content>
              <base-material-card color="teal">
                <template v-slot:heading>
                  <div class="text-subtitle-1 font-weight-light">
                    Описание выполнения условия
                  </div>
                </template>
                <base-material-alert class="teal lighten-2 teal--text text--lighten-5">
                  {{ explainConditionView.start }}
                </base-material-alert>
                <v-divider />
                <base-material-alert
                  v-for="key in explainCondition"
                  :key="key"
                  class="teal lighten-5 teal--text text--darken-4"
                >
                  {{ explainConditionView[key] }}
                </base-material-alert>
                <v-divider />
                <base-material-alert class="teal lighten-2 teal--text text--lighten-5">
                  {{ explainConditionView.end }}
                </base-material-alert>
              </base-material-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Condition_class from "../../shared/classes/condition_class"
import TaskMenu from "../../shared/components/task-menu/TaskMenu"
import WebApi from "../../shared/modules/web_api"
import ExplainConditionModel from "../../models/explain-condition.model"
import RuleModel from "@/views/loyalty/models/rule.model"
import ConditionItem from "@/views/loyalty/shared/classes/condition-item"
import { ConditionControlEnum } from "@/views/loyalty/models/condtion.model"
import TextDateField from "@/views/loyalty/shared/components/text-date/TextDateField"
import ItemList from "@/views/loyalty/shared/components/item-list/ItemList"
import { JustpayNomenclature } from "@/views/loyalty/shared/services/justpay-nomenclature-service"
import { ConditionService } from "@/views/loyalty/shared/services/condition-service"
import { isEmpty } from "@/views/loyalty/shared/modules/is_object"

export default {
  name: "ConditionList",
  components: { ItemList, ConditionControlEnum, TaskMenu, TextDateField },
  props: {
    customerId: {
      type: String,
      default: ''
    },
    role: {
      type: Number,
      default: 0
    },
    rule: {
      // type: Object,
      // default: {}
    }
  },
  data: () => ({
    attributes: [],
    Condition: {},
    conditionControlEnum: ConditionControlEnum,
    conditionId: 0,
    conditionItems: {},
    conditions: [],
    conditionParameterList: [],
    conditionService: null,
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialog: false,
    dialogVisible: false,
    explainConditionObj: null,
    explainConditionView: {},
    itemList: [],
    headers: [
      {
        text: "Действия",
        value: "actions",
        sortable: false
      },
      {
        text: "Параметр",
        value: "parameterHuman"
      },
      {
        text: "Операция сравнения",
        value: "comparisonOpHuman"
      },
      {
        text: "Значение",
        value: "value"
      },
    ],
    hintDateField: '',
    nomenclatureHeaders: [
        {
            text: "ИД",
            value: "id"
        },
      {
        text: "Код",
        value: "code"
      },
      {
        text: "Наименование",
        value: "name"
      },
      // {
      //   text: "Выбрать",
      //   value: "actions",
      //   sortable: false
      // }
    ],
    nomenclatureList: [],
    nomenclatureService: null,
    selected: '',
      selectedItems: [],
    user: null
  }),
  computed: {
    explainCondition () {
      return Object.keys(this.explainConditionView).filter(
          f => f !== "start" && f !== "end"
      )
    },
    isRuleObject () {
      return this.rule instanceof RuleModel
    }
  },
  watch: {
    rule:
        {
          immediate: true,
          // deep: true,
          async handler (newValue, oldValue) {
            // console.log('watch rule', newValue)
            if (newValue instanceof RuleModel) {
              await this.getItems()
            }
          }
        },
  },
  async beforeMount () {
    // console.clear()
    console.log('conditionControlEnum', this.conditionControlEnum)
    this.webApi = new WebApi(this.$store)
        .deleteSuccess("Условие удалено!")
        .deleteError("Произошла ошибка при удалении Условия!")
        .readError("Произошла ошибка при загрузке условий")
    this.nomenclatureService = new JustpayNomenclature()
    this.conditionService = new ConditionService()
    this.user = this.role === 1 ? 'admin' : 'client'
    this.conditionParameterList = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/condition_param/${this.customerId}`) // this.$store.state.user.current_client
    this.attributes = await this.getAttributes()
  },
  methods: {
    createCondition () {
      this.conditionId = 0
      this.dialog = true
      this.Condition = Condition_class.clearItems()
      this.Condition.ruleId = this.rule.ruleId
      this.conditionItem = new ConditionItem()
          .getFeature(this.Condition.parameter)
          .conditionComparisonOpList()
      Object.assign(this.conditionItems, this.conditionItem.getConditionItems())
      console.log('conditionItems', this.conditionItems)
      // this.attributes = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attributes/`)
      console.log('this.attributes', this.attributes)
      console.log('createCondition this.Condition', this.Condition)
    },
    async deleteCondition (item) {
      console.log(item)
      const resultDeleting = await this.conditionService.deleteCondition(item.conditionId)
      if (resultDeleting) {
        await this.getItems()
      }
    },
    async editCondition (item) {
      console.log('editCondition', item)
      this.conditionId = item.conditionId
      this.Condition = await this.conditionService.getCondition(this.conditionId)
        const attribute = this.attributes.find(f => f.mnemonic === this.Condition.parameter)
        console.log('attribute', attribute)
        console.log('this.Condition', this.Condition)
        console.log(typeof this.Condition.value)
        this.conditionItem = new ConditionItem()
            .getFeature(this.Condition.parameter, attribute)
            .conditionComparisonOpList()
            .getUrl(this.Condition.parameter)
        Object.assign(this.conditionItems, this.conditionItem.getConditionItems())
        console.log('conditionItems', this.conditionItems)
      this.dialog = true
    },
    makeHint (dateValue) {
      console.log('dateValue:', dateValue)
      let values = null
      if (Array.isArray(dateValue)) {
        values = dateValue.length > 0 ? dateValue[0].split('.') : ''
      } else {
        values = dateValue.split('.')
      }
      const message = (values.length === 1) ? `Будет выполняться каждый раз ${values[0]}-го числа каждого месяца.`
          : (values.length === 2) ? `Будет выполняться каждый раз ${values[0]}-го числа, ${values[1]}-го месяца.`
              : (values.length === 3) ? `Будет выполняться каждый раз ${values[0]}-го числа ${values[1]}-го месяца, ${values[2]} года.`
                  : 'Дата должна быть вида ДД.ММ.ГГГГ'
      return message
    },
    getAttributes () {
      return this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attributes/`).then(response => {
        return response
      })
    },
    async getItems () {
      console.log('getItems rule', this.rule)
      this.explainConditionObj = new ExplainConditionModel(
          this.rule
      ).init()
      console.log(
          `this.explainConditionObj.getExplain()=${JSON.stringify(
              this.explainConditionObj.getExplain()
          )}`
      )

      console.log("Rule=" + JSON.stringify(this.rule))
      if (this.rule) {
        console.log('this.conditionService:', this.conditionService)
        const conditions = await this.conditionService.getConditions(this.rule.ruleId)
        this.conditions = conditions.map(item => this.setItems(item))
        this.explainConditionView = this.explainConditionObj
            .end()
            .getExplain()
        console.log(
            'this.explainConditionObj.getExplain()', this.explainConditionView
        )
      }
    },
    onCloseDialog () {
      this.dialog = false
    },
    onCloseDialogNomenclature () {
      this.dialogVisible = false
    },
    async onCreate () {
      const that = this
      console.log("create")
      const data = Object.assign({}, this.Condition)
      delete data.conditionId
      const conditionCreated = await this.conditionService.createCondition(data)
      console.log('conditionCreated:', conditionCreated)
      that.Condition.conditionId = conditionCreated.conditionId
      await that.getItems()
      this.dialog = false
    },
    onDateChange ($emit) {
      // console.log('onDateChange', $emit)
      this.hintDateField = this.makeHint($emit)
    },
    onGetNomenclatureCode (nomenclatures) {
      console.log('nomenclature nomenclature:', nomenclatures)
      // if (!Array.isArray(this.Condition.value)) {
      //   this.Condition.value = this.Condition.value.toString().split(',')
      // }
        this.Condition.value.splice(0, this.Condition.value.length)
        nomenclatures.forEach(nomenclature => {
            this.Condition.value.push(nomenclature.code)
        })
    },
    async onGetParameter () {
      console.log('onGetParameter', this.Condition.parameter)
      this.Condition.value = []
      const attribute = this.attributes.find(f => f.mnemonic === this.Condition.parameter)
      console.log('attribute', attribute)
      Object.assign(
          this.conditionItems,
          this.conditionItem
              .getFeature(this.Condition.parameter, attribute)
              .conditionComparisonOpList()
              .getUrl(this.Condition.parameter)
              .getConditionItems()
      )
      if (attribute !== undefined) {
        if (attribute.type === 5) {
          const customVariables = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/customer_variables/${this.customerId}`)
          const item = customVariables.find(customVariable => customVariable.nickname === attribute.name).byDefault
          this.itemList = item.split(';')
        }
      }
      console.log('conditionItems', this.conditionItems)
    },
    async onOpenDialog () {
      console.log("dialog is open")
      this.nomenclatureList = await this.nomenclatureService.getNomenclatureForHeader(this.customerId)
      console.log('this.nomenclatureList:', this.nomenclatureList)
        // fill selectedItem
        this.selectedItems = this.nomenclatureList.filter(nomenclature => this.Condition.value.includes(nomenclature.code))
      this.dialogVisible = true
    },
    async onSave () {
      console.log("saving...")
      console.log('this.Condition:', this.Condition)
      await this.conditionService.updateCondition(this.Condition.conditionId, this.Condition)
      await this.getItems()

      this.dialog = false
    },
    setItems (data) {
      this.explainConditionObj.add(data, this.conditionParameterList)
      return new Condition_class(data).conditionParameters(this.conditionParameterList).item
    }
  }
}
</script>

<style scoped>
.check-box {
  height: 24px;
  width: 24px;
}
.col-check-box {
  text-align: center;
  align-self: center;
}
</style>
